import React from 'react';

import { FormInstance } from 'antd';
import {
  Switch,
  Input,
} from 'UI';

import {
  FormContainer,
  BaseFormItem,
} from './style';

export interface UpdateUserFormData {
  name: string
  email: string
  isAdmin: boolean
  isActive: boolean
}

interface UpdateFormProps {
  formHandler: FormInstance
  onSubmit(data: unknown): void
  isLoading?: boolean
  data: UpdateUserFormData
  onDataChange?(changedValue: unknown, formData: unknown): void
  isCurrentUser?: boolean
}

const UpdateForm = ({
  formHandler,
  onSubmit,
  isLoading,
  data,
  onDataChange,
  isCurrentUser,
}: UpdateFormProps): JSX.Element => (
  <FormContainer
    layout="vertical"
    form={formHandler}
    requiredMark={false}
    onFinish={onSubmit as (val: unknown) => void}
    onValuesChange={onDataChange}
    initialValues={data}
  >
    <BaseFormItem
      label="Nome"
      name="name"
      rules={[
        {
          required: true,
          message: 'Insira um nome',
        },
      ]}
    >
      <Input placeholder="Nome do usuario" disabled={isLoading} />
    </BaseFormItem>
    <BaseFormItem
      label="E-mail"
      name="email"
      rules={[
        {
          required: true,
          message: 'Insira um e-mail',
        },
      ]}
    >
      <Input placeholder="Email do usuario" disabled={isLoading} />
    </BaseFormItem>
    <BaseFormItem
      label="Administrador"
      name="isAdmin"
      valuePropName="checked"
    >
      <Switch disabled={isLoading || isCurrentUser} />
    </BaseFormItem>
    <BaseFormItem
      label="Ativo"
      name="isActive"
      valuePropName="checked"
    >
      <Switch disabled={isLoading || isCurrentUser} />
    </BaseFormItem>
  </FormContainer>
);

UpdateForm.defaultProps = {
  isLoading: false,
  onDataChange: () => {},
  isCurrentUser: false,
};

export default UpdateForm;
